import React from 'react';
import { cn } from '@/shared/lib/utils';

interface BillingToggleProps {
    isYearly: boolean;
    onChange: (isYearly: boolean) => void;
}

export const BillingToggle: React.FC<BillingToggleProps> = ({ isYearly, onChange }) => {
    return (
        <div className="mt-12 flex justify-center">
            <div className="relative flex rounded-full bg-card p-1 shadow-md ring-1 ring-border">
                <button
                    type="button"
                    className={cn(
                        "relative w-32 rounded-full py-2 text-sm font-semibold whitespace-nowrap focus:outline-none focus:z-10 transition-colors duration-200",
                        !isYearly ? "bg-primary text-primary-foreground shadow" : "text-muted-foreground hover:text-foreground"
                    )}
                    onClick={() => onChange(false)}
                >
                    Monthly
                </button>
                <button
                    type="button"
                    className={cn(
                        "relative w-32 rounded-full py-2 text-sm font-semibold whitespace-nowrap focus:outline-none focus:z-10 transition-colors duration-200",
                        isYearly ? "bg-primary text-primary-foreground shadow" : "text-muted-foreground hover:text-foreground"
                    )}
                    onClick={() => onChange(true)}
                >
                    Yearly
                </button>
            </div>
        </div>
    );
};
